import { Card, Col, Row } from "react-bootstrap";
import Overview from "../Common/Overview";
import ShadowCard from "../Common/ShadownCard";
import ContentEngagement from "../Common/ContentEngagement";
import ContentDistribution from "../Common/ContentDistribution";
import TopEngagement from "../Common/TopEngagement";
import { useEffect, useState, useRef } from "react";
import { getData } from "../../../axios/apiHelper";
import { loader } from "../../../loader";
import axios from "../../../axios/index";
import { saveAs } from "file-saver";
import { toPng } from "html-to-image";

export default function VwdDashboard() {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [isSummaryDownloading, setIsSummaryDownloading] = useState(false);
  const [isCapturing, setIsCapturing] = useState(false);
  const dashboardRef = useRef(null);

  const handleCaptureImage = async () => {
    if (!dashboardRef.current) return;
    try {
      setIsCapturing(true);
      loader("show");
      const dataUrl = await toPng(dashboardRef.current, {
        cacheBust: true,
        backgroundColor: "#f4f7fa", // Matching the dashboard background if needed, or white
      });
      saveAs(dataUrl, `vwd_stats_${new Date().toISOString().slice(0, 10)}.png`);
    } catch (error) {
      console.error("Error capturing image:", error);
    } finally {
      loader("hide");
      setIsCapturing(false);
    }
  };

  const handleDownloadSummary = async () => {
    try {
      setIsSummaryDownloading(true);
      loader("show");
      const response = await axios.get(
        "/narrative/download-unmet-summary?scope=dashboard",
        { responseType: "blob" },
      );
      const excelBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(excelBlob, `vwd_journey_summary_${new Date().toISOString().slice(0, 10)}.xlsx`);
    } catch (error) {
      console.error("Error downloading dashboard summary excel:", error);
    } finally {
      loader("hide");
      setIsSummaryDownloading(false);
    }
  };

  useEffect(() => {
    const getUnmetAnalytics = async () => {
      try {
        loader("show");
        // const response = await getData("/narrative/get-unmet-analytics?id=105");
        const response = await getData("/narrative/get-unmet-analytics");
        if (response.status === 200) {
          setAnalyticsData(response.data?.data);
        }
        loader("hide");
      } catch (error) {
        console.error("Error fetching unmet analytics:", error);
        loader("hide");
      }
    };
    getUnmetAnalytics();
  }, []);

  return (
    <Col className="right-sidebar custom-change vwd-dashboard">
      <div className="custom-container">
        <Row>
          <div className="top-header profile_header sticky">
            <div className="page-title d-flex align-items-start">
              <div className="d-flex flex-column">
                <h2 className="d-flex align-items-center gap-1">VWD Journey</h2>
                {/* <p className="d-flex align-items-center p-0">April. 22. 2024</p> */}
              </div>
            </div>

            <div className="top-right-action">
              <div class="action-btn-add">
                <button
                  type="button"
                  class="btn-filled btn-downloaded   btn btn-primary"
                  onClick={handleDownloadSummary}
                  disabled={isSummaryDownloading}
                >
                  Summary (Excel)
                  <img
                    src="https://informed.pro/componentAssets/images/download.svg"
                    alt="icon"
                  />
                </button>
              </div>
              <div class="action-btn-add">
                <button
                  type="button"
                  class="btn-white btn-capture    btn btn-primary"
                  onClick={handleCaptureImage}
                  disabled={isCapturing}
                >
                  <img
                    src="https://informed.pro/componentAssets/images/camera.svg"
                    alt="icon"
                  />
                </button>
              </div>
            </div>
          </div>
          <div ref={dashboardRef} className="vwd-dashboard-container d-flex flex-column gap-4">
            <div className="graph-container d-flex justify-content-between gap-3 pt-1">
              <div className="overview-box">
                <div className="profile-box-title">
                  <p>Overview</p>
                </div>
                <Overview
                  data={{
                    users: analyticsData?.users,
                    totalVisits: analyticsData?.analyticsData?.totalVisits,
                    hcpVisits: analyticsData?.analyticsData?.hcpVisits,
                    octaVisits: analyticsData?.analyticsData?.octaVisits,
                    avgHcpDuration:
                      analyticsData?.analyticsData?.avgHcpDuration,
                    avgOctaDuration:
                      analyticsData?.analyticsData?.avgOctaDuration,
                  }}
                />
              </div>
              <div className="content-box">
                <div className="profile-box-title">
                  <p>Content engagement</p>
                </div>
                <ContentEngagement
                  data={{
                    line: analyticsData?.analyticsData?.engagement,
                    pie: analyticsData?.analyticsData?.contentEngagement,
                  }}
                />
              </div>
              <div className="distribution-box">
                <div className="profile-box-title">
                  <p>Content distribution</p>
                </div>
                <ContentDistribution
                  data={analyticsData?.analyticsData?.distribution}
                />
              </div>
            </div>
            <div className="graph-container d-flex top-engagement">
              <ShadowCard title={"Top 5 Engagement"} colSize={12}>
                <TopEngagement  type={"dashboard"} 
                  regions={analyticsData?.analyticsData?.topRegions}
                  filters={analyticsData?.analyticsData?.topFilters}
                  contents={analyticsData?.analyticsData?.overAllPdfOpeniing}
                />
              </ShadowCard>
            </div>
          </div>
        </Row>
      </div>
    </Col>
  );
}
